<template>
    <div class="cabinet-menu">
        <div class="cabinet-menu__block" v-for="(item, i) in items.slice(0, items.length - 1)">
            <router-link
                :key="i"
                :to="item.href"
                class="cabinet-menu__link"
                exact-path
                @click="handlerClick(i)"
            >
                {{ item.name }}
                <svg v-if="screenWidth < 768 && !item.active">
                    <use xlink:href="#svg-plus"></use>
                </svg>
                <svg v-if="screenWidth < 768 && item.active">
                    <use xlink:href="#svg-minus"></use>
                </svg>
            </router-link>
<!--            <a-->
<!--                @click="loadMenuSection(item.href); handlerClick(i)"-->
<!--                href="javascript:void(0)"-->
<!--                class="cabinet-menu__link"-->
<!--                :class="{'cabinet-menu__link_active':item.active}"-->
<!--            >-->
<!--                {{ item.name }}-->
<!--                <svg v-if="screenWidth < 768 && !item.active">-->
<!--                    <use xlink:href="#svg-plus"></use>-->
<!--                </svg>-->
<!--                <svg v-if="screenWidth < 768 && item.active">-->
<!--                    <use xlink:href="#svg-minus"></use>-->
<!--                </svg>-->
<!--            </a>-->
            <slot v-if="item.active"></slot>
        </div>
        <div class="cabinet-menu__block">
            <a
                :href="items[ items.length -1 ].href"
                class="cabinet-menu__link cabinet-menu__exit"
            >
                {{ items[ items.length -1 ].name }}
                <svg v-if="screenWidth < 768 && !items[ items.length -1 ].active">
                    <use xlink:href="#svg-plus"></use>
                </svg>
                <svg v-if="screenWidth < 768 && items[ items.length -1 ].active">
                    <use xlink:href="#svg-minus"></use>
                </svg>
            </a>
        </div>
        <!--<a href="javascript:void(0)" class="cabinet-menu__link">
            <svg><use xlink:href="#svg-exit"></use></svg>
            вихід
        </a>-->
    </div>
</template>

<script>
    export default {
        name: 'cabinet-menu',
        props: {
            result: {
                type: [Object],
            },
        },
        data() {
            return {
                items: this.result.items,
            }
        },
        methods: {
            loadMenuSection(url) {
                this.$store.dispatch('personalCabinet/loadMenuSection', url);
            },
            handlerClick(i) {
                this.items =  this.items.map((el, key) => ({
                    ...el,
                    active: i === key,
                }))
            },
        },
        // computed: {
        //     isActive() {
        //
        //     }
        // },
        mounted() {
            console.log(this.$el.children[0].children)
            console.log(this.$refs)
        }
    }
</script>

<style lang="scss" scoped>
    .cabinet-menu{
        display: flex;
        flex-direction: column;
        background-color: #fff;
        @include point-md{
            padding: 16px 32px 18px;
        }
        &__link{
            display: flex;
            align-items: center;
            justify-content: space-between;
            text-transform: uppercase;
            font-size: rem(14);
            padding: 16px 16px 14px;
            font-weight: 500;
            line-height: 100%;
            letter-spacing: 0.08em;
            color: #191918;
            @include point-md{
                padding: 16px 0 14px;
                font-size: rem(16);
            }
            //&_active{
            //    color: var(--text-colour-secondary);
            //}
            svg{
                width: 16px;
                height: 16px;
                @include point-md{
                    margin-right: 8px;
                }
            }
        }
        &__block{
            &:not(:last-child) {
                border-bottom: 1px solid #DFDFDF;
            }
        }
        :deep(.router-link-exact-active){
            color: var(--text-colour-secondary);
        }
    }
</style>